var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "About",
    d: "M3.34125 12.3077L0 15V0.769231C0 0.565218 0.0790176 0.369561 0.21967 0.225302C0.360322 0.0810437 0.551088 0 0.75 0H14.25C14.4489 0 14.6397 0.0810437 14.7803 0.225302C14.921 0.369561 15 0.565218 15 0.769231V11.5385C15 11.7425 14.921 11.9381 14.7803 12.0824C14.6397 12.2266 14.4489 12.3077 14.25 12.3077H3.34125ZM3.75 5.38462V6.92308H5.25V5.38462H3.75ZM6.75 5.38462V6.92308H8.25V5.38462H6.75ZM9.75 5.38462V6.92308H11.25V5.38462H9.75Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/About.aaa7a022f6f2f6223ef506b4ab95f8d6.svg";
export { ForwardRef as ReactComponent };